import { getActiveBuildings } from "./index24.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { ResizeRgObj } from "@project-rouge/rg-three";
const pipeResize = ([parent, { buildingIds, aggProps }]) => {
	const buildings = getActiveBuildings(parent, aggProps);
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		const toResize = [
			RG_TYPE.Core,
			RG_TYPE.Corridor,
			RG_TYPE.Entrance
		];
		for (let i = 0; i < building.children.length; i++) {
			const obj = building.children[i];
			if (!toResize.includes(obj.type)) continue;
			building.children[i] = ResizeRgObj({
				rgObj: obj,
				useCache: false
			});
		}
	}
	return [parent, void 0];
};
export { pipeResize };

//# sourceMappingURL=index179.js.map